import dynamic from 'next/dynamic';
import { yupResolver } from '@hookform/resolvers/yup';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Controller, useForm } from 'react-hook-form';
import * as yup from 'yup';
import Link from 'next/link';

import { getLocaleIP, getUserLocationData } from 'app/scripts/utils';
import { timeZoneCityToCountry } from 'app/helpers/timeZoneCityToCountry';
import REQUEST from 'app/helpers/http.service';
import { ALL_SUBMIT_FORM } from 'app/helpers/apiEndpoint';
import { getTrackingData } from 'app/webtrack/tracking';
import { validatePhoneNumber } from 'app/scripts/validatePhoneNumber';

import { TextInput } from '../FormComponent/TextInput';
import { Textarea } from '../FormComponent/Textarea';
import { PhoneNumberInput } from '../FormComponent/PhoneNumberInput';

import FormButton from './FormButton';
const Captcha = dynamic(() => import('./Captcha'), {
  ssr: false,
});
const style = {
  inputField: {
    borderTop: '0px',
    borderLeft: '0px',
    borderRight: '0px',
    border: '1px solid #FFFFFF42',
    backgroundColor: '#10172A',
    // borderRadius: "4px",
    padding: '2px 10px',
    height: '45px',
    fontWeight: '500',
    borderRadius: '4px',
  },
  whiteCard: { boxShadow: '0px 0px 25px rgba(0, 0, 0, 0.1)' },
  selectArrow: {
    backgroundImage: 'url(../img/contact-us/Vector.svg)',
    backgroundPosition: 'calc(100% - 15px) center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '16px',
  },
};
export default function ContactForm({ title }) {
  const { asPath } = useRouter();
  const router = useRouter();
  const toast = useSelector(state => state?.toast);
  const [captchaError, setCaptchaError] = useState(false);
  const [phone, setPhone] = useState('');

  const [phoneError, setPhoneError] = useState('');
  const [locationip, setLocationIP] = useState(false);
  const [captchaVerified, setCaptchaVerified] = useState(false);
  const [isDefaultChecked, setIsDefaultChecked] = useState(true);

  const locationData = getUserLocationData(timeZoneCityToCountry);

  useEffect(() => {
    const fetchIP = async () => {
      const { ip } = await getLocaleIP();
      setLocationIP(ip);
    };

    fetchIP();
  }, []);
  const handleCheckboxChange = e => {
    setIsDefaultChecked(e.target.checked);
  };

  const handleCaptchaVerify = isValid => {
    setCaptchaVerified(isValid);
  };
  // .matches(
  //   /^(?!.*@(?:gmail|outlook|yahoo|protonmail|zoho|aol)\.\w{2,}$)[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  //   'Work email addresses are allowed'
  // ),
  const Schema = yup.object().shape({
    email: yup
      .string()
      .email('Invalid email format')
      .required('Email is required'),
    name: yup
      .string()
      .required('Name is required')
      .matches(/^[a-zA-Z\s]*$/, 'Name must contain only letters and spaces'),
    organization: yup
      .string()
      .required('Organization Name is required')
      .matches(/^[a-zA-Z\s]*$/, 'Organization Name can not contain number'),
    description: yup.string().required('Message is required'),
  });

  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(Schema),
    defaultValues: {
      // phoneNumber: '',
      name: '',
      description: '',
      organization: '',
      email: '',
      countryName: locationData.userCountry,
      pageUrl: asPath,
      pervious_page: '',
      ctaText: 'Submit',
      leadSource: title,
      purpose: 'LEADS',
      subscribeCheckbox: isDefaultChecked,
    },
  });
  // LEADS

  const SubmitHandler = async data => {
    const validationError = validatePhoneNumber(phone);
    if (!validationError) {
      if (!captchaVerified) {
        setCaptchaError(true);
      } else {
        try {
          const trackingData = getTrackingData();

          // Ensure WebPagesVisited is a proper string
          const cleanedTrackingData = {
            ...trackingData,
            WebPagesVisited: Array.isArray(trackingData?.WebPagesVisited)
              ? trackingData.WebPagesVisited.join(', ') // Convert array to comma-separated string
              : trackingData?.WebPagesVisited || '', // Ensure it's a string
          };

          const formData = {
            ...data,
            phoneNumber: phone,
            ipAddress: locationip,
            trackingData: cleanedTrackingData, // Use cleaned tracking data
          };

          const res = await REQUEST({
            method: 'POST',
            url: ALL_SUBMIT_FORM,
            data: { data: formData },
          });

          if (res?.status === 200) {
            reset();
            setPhone('');
            // zohoLeadApi({ ...data, firstName: data?.name });
            // subscribeEmail({ ...data });
            router.push('/thankyou');
          } else toast.error(res?.data?.error?.message);
        } catch (err) {
          toast.error('failed');
        }
      }
    } else {
      setPhoneError(validationError);
    }
  };

  return (
    <form
      onSubmit={handleSubmit(SubmitHandler)}
      className="py-10 lg:px-[50px] p-8 lg:h-full"
    >
      <div className="text-[24px] text-[#fff] font-[700] pb-10">
        Request a proposal
        <span className="w-[100px] h-[3px] bg-[#0050D5] block"></span>
      </div>
      <TextInput
        topDivCss="mb-[25px]"
        register={register}
        name="name"
        errors={errors}
        style={style.inputField}
        labelstyle={{ background: 'transparent' }}
        label="Enter Full Name*"
        labelCss={'text-[#fff] text-[14px] font-[400] mb-1 block'}
        className={
          'text-[16px] w-[100%] block outline-0 placeholder-[#FFFFFF] text-[#FFFFFF] bg-[#10172A] border border-[#FFFFFF42] rounded-[4px] focus:ring-0 focus:border-[#FFFFFF42]'
        }
      />
      <TextInput
        topDivCss="mb-[25px]"
        register={register}
        name="email"
        errors={errors}
        style={style.inputField}
        labelstyle={{ background: 'transparent' }}
        label="Enter Work Mail*"
        labelCss={'text-[#fff] text-[14px] font-[400] mb-1 block'}
        className={
          'text-[16px] w-[100%] block outline-0 placeholder-[#FFFFFF] text-[#FFFFFF] bg-[#10172A] border border-[#FFFFFF42] rounded-[4px] focus:ring-0 focus:border-[#FFFFFF42]'
        }
      />
      <PhoneNumberInput
        phone={phone}
        setPhone={setPhone}
        phoneError={phoneError}
        setPhoneError={setPhoneError}
        validatePhoneNumber={validatePhoneNumber}
        topDivCss="mb-[25px]"
        label="Contact Number*"
        labelCss="text-[#fff] text-[14px] font-[400] mb-1 block"
        name="phoneNumber"
        style={style.inputField}
        phoneclassName="p-[0px_!important] phonenumber react-tel-input focus:ring-0 placeholder-[#FFFFFF] text-[#FFFFFF]"
      />
      <TextInput
        topDivCss="mb-[25px]"
        label="Organization Name*"
        register={register}
        name="organization"
        errors={errors}
        type="text"
        labelstyle={{ background: 'transparent' }}
        labelCss={'text-[#fff] text-[14px] font-[400] mb-1 block'}
        style={style.inputField}
        className={
          'text-[16px] w-[100%] block outline-0 placeholder-[#ffffff] text-[#ffffff] bg-[#10172A] border border-[#FFFFFF42] rounded-[4px] focus:ring-0 focus:border-[#FFFFFF42]'
        }
      />
      <Textarea
        topDivCss="mb-[25px] w-[100%]"
        register={register}
        errors={errors}
        rows="3"
        name="description"
        labelstyle={{ background: 'transparent' }}
        label="How can we help you? *"
        labelCss="text-[#fff] text-[14px] font-[400] mb-1 block"
        className="text-[16px] w-[100%] block h-auto resize-none outline-0 text-[#ffffff] h-[144px] bg-[#10172A] border border-[#FFFFFF42] rounded-[4px] focus:ring-0 focus:border-[#FFFFFF42]"
      />
      <div className="mb-[25px]">
        <Captcha
          onVerify={handleCaptchaVerify}
          captchaError={captchaError}
          textColor={'#ffffff'}
        />
      </div>
      <div className="mb-[25px] flex items-start space-x-1 text-[#fff]">
        <Controller
          name="subscribeCheckbox"
          control={control}
          render={({ field }) => (
            <input
              type="checkbox"
              className="form-checkbox rounded-full text-[#fff] bg-[#fff] border-[#fff] mr-2"
              {...field}
              onChange={e => {
                field.onChange(e);
                handleCheckboxChange(e);
              }}
              defaultChecked={isDefaultChecked}
            />
          )}
        />
        <span className="text-[#ffffff] text-[14px]  font-[400]">
          By opting in for text messages, you agree to receive messages from
          VLink INC at the number provided. Message frequency varies. Msg & data
          rates may apply. Reply STOP to unsubscribe. Reply HELP for assistance.
          View our
          <Link
            href="/privacy-policy"
            className="underline mx-2 inline-block text-[#4891FF]"
          >
            Privacy Policy
          </Link>
          and
          <Link
            href="/terms-and-conditions"
            className="underline mx-2 inline-block text-[#4891FF]"
          >
            Terms & Conditions
          </Link>
          for more information.
        </span>
      </div>
      <FormButton
        type="submit"
        btnclassName="btnleftright mt-4 bg-[#0050D5] border border-[#0050D5] font-[700] md:text-[20px] w-full text-[14px] text-[#fff] rounded-[4px] shadow-[0px_0px_6px_rgba(0,0,0,0.1)] relative overflow-hidden"
        spanclassName="relative z-[5] transition duration-300 ease-in-out"
        text="Submit"
      />
    </form>
  );
}
